import { DevBoxOperation } from '../../models/dev-box';
import { createStringIdAdapter } from './common/string-id-adapter';

export const devBoxOperationAdapter = createStringIdAdapter<DevBoxOperation>();
